import FieldStatus from "../../../generic/status/status"

import FieldConfig from "../../../proto/field-config"
import FieldTaskStatus_QuickFilterView from "./render/quick-filter-view"
import FieldTaskStatus_ViewSmall from "./render/view-small"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import FieldTaskStatus_AutomationTriggerForm from "./render/automation/automation-trigger-form"
import FieldTaskStatus_AutomationConditionForm from "./render/automation/automation-condition-form"
import FieldTaskStatus_AutomationActionForm from "./render/automation/automation-action-form"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types"
import {SortDirection} from "../../../../data-structures/sort"
import FieldTaskStatus_GraphTickLabelView from "./render/graph-tick-label"
import {ItemColorCoding, ColorPalette, DefaultPaletteColorNumber} from "../../../color-coding/color-coding";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldTaskStatus_TableCell from "./render/table/table-cell"
import FieldStatus_PopoverMore from "./components/popover/popover-menu-more";
import FieldStatus_PopoverOption from "../../../generic/status/components/popover/option"
import Task from "../../../../model2/task/task"
import FieldTaskStatus_ViewProperty from "./render/view-property"
import {FieldFilterType} from "../../../proto/types";
import FieldTaskStatus_TableCellCalculated from "./render/table/calculated/table-cell-calculated"
import FieldTaskStatus_ViewGroup from "./render/group/group"

const debug = false
// const debug = "FieldTaskStatus"

// It's no a standard popover menu at all ... not even shure why dropdown ... I guess becuase of options ?


export default class FieldTaskStatus extends FieldStatus {

    FIELD_DEFAULT_WIDTH = 150

    constructor(config:FieldConfig) {
        super(config)

        // options and edit is not implemented for status yet

        this.conditionTypes     = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel          = "Status"
        this.filterType         = FieldFilterType.DROPDOWN
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Status field"

        this.icon               = 'i5-statuses'

        this.groupByDefaultSortDirection    = SortDirection.ASC

        this.options            = [] // Task statuses here

        this.noValueOption      = false

        this.isSearchable       = false
        this.isFilterAvailable  = true

        // const statuses = gd.session.taskTypes.get(id) // Where to get TaskTypeId from?

        this.components.PopoverOption       = FieldStatus_PopoverOption
        this.components.PopoverMenuMore     = this.showMenuMore ? FieldStatus_PopoverMore : null


        _.assign(this.renderComponents,{

            quickFilterView         : FieldTaskStatus_QuickFilterView,

            automationTriggerForm   : FieldTaskStatus_AutomationTriggerForm,
            automationActionForm    : FieldTaskStatus_AutomationActionForm,

            graphTickLabelView      : FieldTaskStatus_GraphTickLabelView
        })

        this.renderComponents.viewSmall                     = FieldTaskStatus_ViewSmall
        this.renderComponents.automationConditionForm       = FieldTaskStatus_AutomationConditionForm

        this.renderComponents.tableCell                     = FieldTaskStatus_TableCell
        this.renderComponents.tableCellCalculated           = FieldTaskStatus_TableCellCalculated

        this.renderComponents.viewProperty                  = FieldTaskStatus_ViewProperty
        this.renderComponents.viewGroup                     = FieldTaskStatus_ViewGroup

    }

    // ACCESS
    canEdit(task: Task): boolean {
        return task.acl.canChangeStatus
    }


    getOptionsForEdit(model:any) {
        return []
    }


    groupValue(value:any) {
        const status = gd.session.statuses.get(value)
        return status ? status.id : null
    }

    groupLabel(value:any) {
        const status = gd.session.statuses.get(value)
        return status ? status.name : value
    }

    groupSortValue(value:ID) {

        // Experimental by vic before was just id
        // used at least in dashbaord

        const status = gd.session.statuses.get(value)

        if (!status) return null

        return status.systemStatus+'-'+status.name
    }

    sortValue(value:any) {
        const status = gd.session.statuses.get(value)
        return status ? status.name.toLowerCase() : ''
    }

    get requiredBackendFields():string[] {
        return ['taskStatusId']
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        const searchValue: string = value.toLowerCase().trim()

        // we search within all available statuses
        const sessionStatus = _.find(gd.session.statuses.models, (sessionStatus) => {
            return sessionStatus.name.toLowerCase().trim() === searchValue
        })

        if (sessionStatus) return sessionStatus.id
        return null
    }

    getGraphColor(model:any|null, params: any) {
        const value = _.get(model, this.fieldId, null)
        const status = gd.session.statuses.get(value)

        debug && console.log(debug, 'getGraphColor', status, gd.const.statusColorValue)

        return status ? gd.const.statusColorValue[status.color] : super.getGraphColor(model, params)
    }

    getColorCoding(model: any): ItemColorCoding {
        const value = _.get(model, this.fieldId, null)
        const status = gd.session.statuses.get(value)

        return {
            colorNumber         : status?.color || DefaultPaletteColorNumber.STATUS,
            corePalette         : ColorPalette.STATUS
        }
    }
}
